import ICOIconContainer from "../../Component/Icons/ICOIcon/ICOIcon"

const ICOIcon = () => {
  return (
    <div className='page-body'>
      <ICOIconContainer />
    </div>
  )
}

export default ICOIcon